import * as Styled from '../../styles/UsuariosAprovados.styles';
import { useEffect, useState, useMemo } from 'react';
import Modal from '../../../../components/Modal/Modal';
import { imageAction } from '../../../../store/fetchActions/imageActions';
import { useDispatch } from 'react-redux';
import { Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';
import convertBase64 from '../../../../utils/functions/convertBase64';

export default function DocumentRepresentative({ document }) {
  const dispatch = useDispatch();

  const [selectedImage, setSelectedImage] = useState(0);
  const [imageName, setImageName] = useState('');
  const [isModalImageOpen, setIsModalImageOpen] = useState(false);

  const changeImage = (newURL, name, index) => {
    setSelectedImage(index);
    dispatch(imageAction(newURL));
    setImageName(name);
  };

  const { typeImage, imgData, loadingImage } = useSelector((selector) => selector.image);

  const urlImg = useMemo(() => convertBase64(imgData, typeImage), [imgData]);

  return (
    <Styled.ContainerDocRepresentative>
      <Styled.TitleStyled>Documentos</Styled.TitleStyled>
      <Styled.DocContaineRepresentative>
        {document?.map((documento, index) => {
          return (
            <Styled.Taxa key={index}>
              <Styled.ImageButton
                index={index}
                selectedImage={selectedImage}
                onClick={() => {
                  changeImage(documento.CAMINHO_ARQUIVO, documento.DESCRICAO, index), setIsModalImageOpen(true);
                }}
                type="button"
              >
                {documento.DESCRICAO}
              </Styled.ImageButton>
            </Styled.Taxa>
          );
        })}
      </Styled.DocContaineRepresentative>

      {isModalImageOpen && (
        <Modal
          open={isModalImageOpen}
          close={() => setIsModalImageOpen(false)}
          title={imageName}
          width={typeImage === 'application/pdf' && !loadingImage ? '1000px' : 'auto'}
        >
          <>
            {loadingImage ? (
              <Skeleton variant="rounded" width={'550px'} height={350} />
            ) : typeImage === 'application/pdf' ? (
              <object data={urlImg} type="application/pdf" width="100%" height="800px"></object>
            ) : (
              <img src={`data:${typeImage};base64,${imgData}`} style={{ width: '100%' }} />
            )}
          </>
        </Modal>
      )}
    </Styled.ContainerDocRepresentative>
  );
}
